module.exports = __webpack_public_path__ + "img/map.b989085f.png";